class GiftWithPurchase {
  constructor () {
    this.opt1_dataElements = document.querySelectorAll(
      '[data-gift-with-purchase-el="opt1_data"]'
    )
    this.opt2_dataElements = document.querySelectorAll(
      '[data-gift-with-purchase-el="opt2_data"]'
    )

    if (!this.isEligible()) return

    // Get the current URL and URL parameters
    // eslint-disable-next-line compat/compat
    this.url = new URL(window.location.href)
    this.urlPathname = this.url.pathname
    // eslint-disable-next-line compat/compat
    this.urlParams = new URLSearchParams(this.url.search)
    this.gwpParam = this.urlParams.get('gwp')

    // For opt1 elements, set the cookie to 'eligible' if URL and parameter match
    this.setEligibilityCookie(this.opt1_dataElements)
  }

  isEligible () {
    return (
      this.opt1_dataElements.length > 0 || this.opt2_dataElements.length > 0
    )
  }

  setEligibilityCookie (elements) {
    elements.forEach(data => {
      const dataUrl = data.dataset.url || '/'
      const dataGwpParameter = data.dataset.gwpParameter
      const cookieName = data.dataset.cookieName
      const cookieLength = parseInt(data.dataset.cookieLength, 10) || 7

      if (this.urlPathname === dataUrl && this.gwpParam === dataGwpParameter) {
        // Set the cookie to 'eligible'
        this.setCookie(cookieName, 'eligible', cookieLength)
      }
    })
  }

  async getProductsToAddRemove () {
    console.info('this.getCartInfo()', await this.getCartInfo())
    const { cartTotal, cartItems } = await this.getCartInfo()
    console.info('GWP - Cart info:', { cartTotal, cartItems })

    const removes = []
    const adds = []

    // Process opt1 data elements
    if (this.opt1_dataElements.length > 0) {
      console.info('Processing opt1_dataElements')
      this.processOpt1DataElements(
        this.opt1_dataElements,
        cartTotal,
        cartItems,
        adds,
        removes
      )
    }

    // Process opt2 data elements
    if (this.opt2_dataElements.length > 0) {
      console.info('Processing opt2_dataElements')
      this.processOpt2DataElements(
        this.opt2_dataElements,
        cartTotal,
        cartItems,
        adds,
        removes
      )
    }

    console.info('GWP - Products to add:', adds)
    console.info('GWP - Products to remove:', removes)

    // Set cookies for valid additions (for opt1_data)
    adds.forEach(data => {
      if (data.dataset.cookieName) {
        const cookieName = data.dataset.cookieName
        const cookieLength = parseInt(data.dataset.cookieLength, 10) || 7
        console.info(`Setting cookie ${cookieName} to 'added'`)
        this.setCookie(cookieName, 'added', cookieLength)
        this.removeGwpParam()
      }
    })

    // Prepare data for bao-cart.js
    const productsToRemove = removes.map(data => {
      const variantId = Number(data.dataset.variantId)
      const item = cartItems.find(
        item =>
          item.variant_id === variantId &&
          item.properties &&
          item.properties._hiddenFreeGift === 'true'
      )
      return {
        key: item?.key,
        variantId,
      }
    })

    const productsToAdd = adds.map(data => {
      const properties = {
        _hiddenFreeGift: 'true', // Always include this property
        // Use the dynamic label from data.dataset.productMessageLabel
        [data.dataset.productMessageLabel]: data.dataset.productMessage,
      }

      if (data.dataset.type === 'opt2') {
        properties._hiddenFreeGiftCookieless = 'true' // Add this property for opt2 products
      }

      return {
        id: Number(data.dataset.variantId),
        quantity: 1,
        properties,
      }
    })

    return { productsToAdd, productsToRemove }
  }

  processOpt1DataElements (elements, cartTotal, cartItems, adds, removes) {
    elements.forEach(data => {
      const variantId = Number(data.dataset.variantId)
      const minCartValue = Number(data.dataset.minCartValue)

      // Check if the variant is in the cart and has the _hiddenFreeGift property
      const inCart = cartItems.some(
        item =>
          item.variant_id === variantId &&
          item.properties &&
          item.properties._hiddenFreeGift === 'true'
      )

      const cookieName = data.dataset.cookieName
      const cookieValue = this.getCookie(cookieName)

      console.info('Processing Opt1 Data Element:', {
        variantId,
        minCartValue,
        inCart,
        cookieName,
        cookieValue,
        cartTotal,
      })

      if (cookieValue === 'eligible') {
        if (cartTotal >= minCartValue && !inCart) {
          // Eligible to add GWP product
          console.info(`Adding variantId ${variantId} to adds`)
          data.dataset.type = 'opt1'
          adds.push(data)
        } else if (cartTotal < minCartValue && inCart) {
          // Cart total below min, remove GWP product
          console.info(`Removing variantId ${variantId} from cart`)
          data.dataset.type = 'opt1'
          removes.push(data)
        }
      } else if (cookieValue === 'added') {
        if (inCart && cartTotal < minCartValue) {
          // Cart total below min, remove GWP product
          console.info(
            `Cart total below minCartValue, removing variantId ${variantId}`
          )
          data.dataset.type = 'opt1'
          removes.push(data)
        }
      }
    })
  }

  processOpt2DataElements (elements, cartTotal, cartItems, adds, removes) {
    elements.forEach(data => {
      const variantId = Number(data.dataset.variantId)
      const minCartValue = Number(data.dataset.minCartValue)
      const maxCartValue = Number(data.dataset.maxCartValue || 9999999)

      // Check if the variant is in the cart and has the _hiddenFreeGift property
      const inCart = cartItems.some(
        item =>
          item.variant_id === variantId &&
          item.properties &&
          item.properties._hiddenFreeGift === 'true'
      )

      console.info('Processing Opt2 Data Element:', {
        variantId,
        minCartValue,
        maxCartValue,
        inCart,
        cartTotal,
        willAdd:
          cartTotal >= minCartValue && cartTotal <= maxCartValue && !inCart,
        willRemove:
          (cartTotal < minCartValue || cartTotal > maxCartValue) && inCart,
      })

      if ((cartTotal < minCartValue || cartTotal > maxCartValue) && inCart) {
        // Cart total not within range, remove GWP product
        console.info(
          `Cart total not within range, removing variantId ${variantId}`
        )
        data.dataset.type = 'opt2'
        removes.push(data)
      } else if (
        cartTotal >= minCartValue &&
        cartTotal <= maxCartValue &&
        !inCart
      ) {
        // Eligible to add GWP product
        console.info(`Cart total within range, adding variantId ${variantId}`)
        data.dataset.type = 'opt2'
        adds.push(data)
      }
    })
  }

  async getCartInfo () {
    try {
      const cart = await fetch('/cart.js').then(res => res.json())

      const cartTotal = cart.items.reduce((total, item) => {
        const keys = Object.keys(item.properties || {})
        if (!keys.includes('_hiddenFreeGift')) {
          return total + item.final_line_price
        } else {
          return total
        }
      }, 0)

      const cartItems = cart.items

      console.info('Fetched cart info:', { cartTotal, cartItems })

      return { cartTotal, cartItems }
    } catch (error) {
      console.error('Error fetching cart total:', error.message)
      return { cartTotal: 0, cartItems: [] }
    }
  }

  setCookie (name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = `expires=${date.toUTCString()}`
    document.cookie = `${name}=${value}; ${expires}; path=/`
  }

  getCookie (name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift()
  }

  removeGwpParam () {
    if (this.gwpParam) {
      this.urlParams.delete('gwp')
      const newUrl = `${this.urlPathname}?${this.urlParams.toString()}`
      window.history.replaceState({}, '', newUrl)
      this.gwpParam = null
    }
  }
}

window.BAO = window.BAO || {}
window.BAO.GiftWithPurchase = new GiftWithPurchase()
